import * as yup from 'yup';
import { fieldRequired } from '../../../../../constants';

export const cmpValidation = yup.object().shape({
  communityBasedProvider: yup.string().required(fieldRequired),
  counselingStaffAssigned: yup.string().required(fieldRequired),
});
